import ReactDOM from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import App from './App';
import { userManager } from './config';

// Silent renew: oidc-client-ts laddar denna väg i en dold iframe för att
// förnya tokens. Iframen ska bara slutföra protokollet – aldrig rendera appen.
if (window.location.pathname === '/authentication/silent-callback') {
  userManager.signinSilentCallback().catch((err) => {
    console.error('Silent renew-callback misslyckades:', err);
  });
} else {
  // Ingen StrictMode: oidc-reacts AuthProvider dubbelmonterar illa i
  // utveckling (samma val som b2b-konto-web/datadelning-web).
  ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
}
